var fn = function( obj ){
var __t,__p='';
__p+='\n'+
( require( "@/webgl/glsl/includes/glsl-compat.vert" )() )+
'\n\nIN vec2 aPosition;\nIN vec2 aTexCoord0;\n\nvoid main(void){\n\n  gl_Position.xy = aPosition;\n  gl_Position.zw = vec2(0.0,1.0);\n  \n}';
return __p;
};
fn.toString=fn;
module.exports = fn;